<template>
  <div class="upload page bg">
    <!-- 文字的区域，和背景图 -->
    <div class="content">
      <div class="title-box">
        <!-- 上面部分的文字 -->
        <div class="title-wrap">
          <p class="title fade1">今年的《政府工作报告》来咯!</p>
          <p class="title fade2">这份<span class="title-sp"> 1万字左右 </span>的报告</p>
          <p class="title fade3">可是蕴藏了不少的民生热点！</p>

          <p class="title title-2 fade4">点击下方<span class="title-sp">“扫一扫”</span></p>
          <p class="title fade5">看看你能解锁多少报告亮点吧！</p>

          <p class="tip tip-1 fade6">提示：常见事物均可扫描，</p>
          <p class="tip fade fade6">比如：一盆花、一支笔、一个人......</p>
        </div>

        <!-- 实现两层阴影 -->
        <div class="title-box-shadow">
          <p class="title fade1">今年的《政府工作报告》来咯!</p>
          <p class="title fade2">这份<span class="title-sp"> 1万字左右 </span>的报告</p>
          <p class="title fade3">可是蕴藏了不少的民生热点！</p>

          <p class="title title-2 fade4">点击下方<span class="title-sp">“扫一扫”</span></p>
          <p class="title fade5">看看你能解锁多少报告亮点吧！</p>
        </div>
      </div>
    </div>

    <!-- 上传图片控件区域，不显示 -->
    <div class="uploader-box">
      <input id="uploader" class="uploader" type="file" accept="image/jpg,image/jpeg,image/png" @change="uploadHandler" />
    </div>

    <div v-show="uploading" class="uploading"></div>

    <!-- 扫一扫按钮 -->
    <div class="btn-box" @click="btnClick">
      <!-- 实际的接收点击事件的上传按钮 -->
      <label class="uploader-agent" for="uploader"></label>
      
      <!-- 按钮的图片，按下和抬起两种状态，不同时出现，互锁 -->
      <img class="btn" :class="{'btn-show': btnState === 'up'}" src="../assets/p2/btn.png" alt="">
      <img class="btn-press" :class="{'btn-show': btnState === 'down'}" src="../assets/p2/btn_press.png" alt="">
    </div>

    <!-- 识别状态的弹窗 -->
    <div v-show="showScanning || showScanFail" class="alert-box">
      <!-- 识别中的弹窗 -->
      <div class="scanning">
        <div v-show="showScanning" class="scanning-content">
          <div class="animate">
            <img class="computer" src="../assets/p3/computer.png" alt="">

            <div class="wave-box">
              <div class="anim-wave">
                <img class="wave" src="../assets/p3/wave.png" alt="">
              </div>
            </div>
          </div>

          <div class="scanning-title">智能分析中...</div>
        </div>
      </div>

      <!-- 识别失败的弹窗 -->
      <div v-show="showScanFail" class="scanfail">
        <div class="computer2">
          <img src="../assets/p3/computer2.png" alt="失败了" />
        </div>

        <div class="retry-btn">
          <img src="../assets/p3/retry.png" alt="重新上传按钮" @click="retry" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import getToken from '../../lib/getToken.js'
// 物品类目数据，和关键词匹配数据，用来生成报告
import { findReport } from '../../lib/keyToTruth'

export default {
  name: 'upload',
  data: function () {
    return {
      // 是否处于上传状态，上传状态时，不响应上传事件
      btnState: 'up', // 扫一扫按钮的状态，up 抬起，down 按下
      uploading: false,
      // 识别中的提示
      showScanning: false,
      // 识别失败的提示
      showScanFail: false,
      // 开始是别的时间，记录下来，最小识别时间2s，
      startTime: 0
    }
  },
  computed: {
    base64 () {
      return this.$store.state.base64
    }
  },
  components: {
    // HelloWorld
  },
  mounted () {
    // console.log('====>video page mounted')
    // 页面渲染完成
    this.$store.commit('setPageReady')

    console.log('upload mounted')

    // 如果是安卓，且微信，input修改accept属性，增加调起摄像头
    if (this.$store.state.isAndroid && this.$store.state.isWeixin) {
      document.getElementById('uploader').accept = 'image/*'
    }

    // 给扫一扫的按钮添加touch事件，按下 抬起的时候，显示不同的按钮图片
    document.getElementsByClassName('btn-box')[0].addEventListener('touchstart', () => {
      this.btnState = 'down'
    }, false)

    document.getElementsByClassName('btn-box')[0].addEventListener('touchend', () => {
      this.btnState = 'up'
    }, false)
  },
  methods: {
    // 点击了扫一扫按钮
    btnClick () {
      // console.log('click')
      this.uploading = true

      // 2秒后再允许点击
      setTimeout(() => {
        this.uploading = false
      }, 2000)
    },

    // 使用 EXIF 来确保上传的文件方向是对的
    rotateImage (localFile, base64) {
      const self = this
      let beforeImageSize = base64.length
      const outputQuality = 0.8

      // 计算上传文件
      let str = base64.substring(22)
      const equalIndex = str.indexOf('=')
      if (str.indexOf('=') > 0) {
        str = str.substring(0, equalIndex)
      }
      const strLength = str.length
      const fileLength = parseInt(strLength - (strLength / 8) * 2)
      if (fileLength < 1024 * 1024) {
        // console.log('文件大小是：', (fileLength / 1000).toFixed(1), ' KB')
      } else {
        // console.log('文件大小是：', (fileLength / 1000 / 1024).toFixed(1), ' MB')
      }

      // 获取照片方向角属性，用户旋转控制
      window.EXIF.getData(localFile, function () {
        // Orientation, 1/0/undefined:不需要旋转，6:旋转90度，3:旋转180度，8:旋转270度
        const orientation = window.EXIF.getTag(this, 'Orientation')

        // 如果 orientation 值是1，或者是 undefined 就不需要旋转了
        const img = document.createElement('img')
        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')

        img.onload = function () {
          // 如果图片的尺寸过大，要压缩
          let imgWidth = img.width
          let imgHeight = img.height
          // const maxSideLength = Math.max(imgHeight, imgWidth)
          let scale = 1
          let realWidth = 0
          let realHeight = 0
          if (imgWidth >= imgHeight && imgWidth > 2000) {
            // 横图或者方图
            scale = 2048 / imgWidth
          } else if (imgHeight >= imgWidth && imgHeight > 2000) {
            // 竖图
            scale = 2048 / imgHeight
          }
          realWidth = imgWidth * scale
          realHeight = imgHeight * scale

          switch (orientation) {
            case 6:
              // 需要旋转90度
              // console.log('====>orientation, ', orientation, '图片需要旋转90度')
              canvas.width = realHeight
              canvas.height = realWidth
              ctx.rotate(Math.PI / 2)
              ctx.drawImage(this, 0, 0, imgWidth, imgHeight, 0, -realHeight, realWidth, realHeight)
              break
            case 3:
              // 需要旋转180度
              canvas.width = realWidth
              canvas.height = realHeight
              // console.log('====>orientation, ', orientation, '图片需要旋转180度')
              ctx.rotate(Math.PI)
              ctx.drawImage(this, 0, 0, imgWidth, imgHeight, -realWidth, -realHeight, realWidth, realHeight)
              break
            case 8:
              // 需要旋转-90度
              // console.log('====>orientation, ', orientation, '图片需要旋转-90度')
              canvas.width = realHeight
              canvas.height = realWidth
              ctx.rotate(3 * Math.PI / 2)
              ctx.drawImage(this, 0, 0, imgWidth, imgHeight, -realWidth, 0, realWidth, realHeight)
              // -imgWidth, 0, imgWidth, imgHeight
              break
            default:
              // 不需要旋转的情况
              canvas.width = realWidth
              canvas.height = realHeight
              ctx.drawImage(this, 0, 0, imgWidth, imgHeight, 0, 0, realWidth, realHeight)
              // console.log('====>orientation, ', orientation, '图片不需要旋转')
          }

          // 将旋转后的图片输出成base64
          // self.base64 =
          // console.log('====>3.旋转图片到正确的角度，完成')

          self.$store.commit('setBase64', canvas.toDataURL('image/jpeg', outputQuality))
          // console.log(`beforeImageSize: ${beforeImageSize}, afterImageSize: ${self.$store.state.base64.length}`)
          // console.log('====>4.图片输出完成')

          self.routeToNextPage()
        }

        img.src = base64
      })
    },

    // 把本地图片解析成base64的数据
    readLocalFile (localFile, cb) {
      // 解析图片，拿到上传图片的base64字符串
      const reads = new FileReader()
      reads.onload = e => {
        cb(e.target.result)
      }

      reads.onerror = error => {
        // 如果读取上传的文件内容失败，弹窗提示，然后让用户重新上传；
        console.log(error)
        this.uploadFiled('图片上传失败，请重试！')
      }

      // 开始读取上传文件的内容
      reads.readAsDataURL(localFile)
    },

    // 上传文件失败的提示
    uploadFiled (error) {
      alert('上传图片失败，请重试', error)
      this.uploading = false
    },

    // 上传事件句柄
    uploadHandler (e) {
      // 如果事件没有文件，或者文件的数量没有大于0，都认为上传失败
      if (!e.target || !e.target.files || !e.target.files.length) {
        this.uploadFiled('失败的具体原因')
        return null
      }

      // 显示阻挡层，避免重复上传
      this.uploading = true

      // 记录开始的时间
      this.startTime = new Date().getTime()

      // console.log('====>1.上传图片到了本地')
      const localFile = e.target.files[0]

      // 将 localFile 读取成 base64 的数据
      this.readLocalFile(localFile, (base64) => {
        // console.log('====>2.图片解析成base64成功')
        // 图片有可能颠倒，旋转图片到正确的角度
        // 需要的参数是 localFile 和转好的 base64
        this.rotateImage(localFile, base64)
      })

      const player = document.getElementById('mp3-making')
      player.play()
    },

    // 上传的图片没有问题，跳转到识别的页面
    routeToNextPage () {
      setTimeout(() => {
        this.uploading = false

        this.showScanning = true

        this.scanImage()
      }, 50)
    },
    
    // 开始识别数据
    async scanImage () {
      // 先检查是不收有百度接口的token，没有的话，就获取下
      if (this.$store.state.tokens.baiduToken === undefined) {
        const token = await getToken()
        this.$store.commit('setToken', {
          bdtoken: token.bdtoken,
          qntaken: token.qntoken
        })
      }

      // 组装formdata，用来请求百度接口
      const bodyFormData = new FormData()
      bodyFormData.append('image', window.encodeURI(this.$store.state.base64.replace(/data:image\/(jpg|jpeg|png);base64,/ig, '')))

      // 请求百度通用接口，查看是别的结果
      // 两种结果：识别成功，识别失败
      axios({
        method: 'post',
        url: 'https://aip.baidubce.com/rest/2.0/image-classify/v2/advanced_general?access_token=' + this.$store.state.tokens.baiduToken,
        data: bodyFormData,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
        .then(response => {
          // console.log(response)
          if (response.status === 200 && response.data.result && response.data.result.length > 0) {
            // 根据识别的结果，生成报告数据
            const objInfo = response.data.result[0]
            const result = findReport(objInfo.root, objInfo.keyword)
            console.log(`识别结果，分类：${objInfo.root}，名称：${objInfo.keyword}`)
            // console.log(`生成的报告：${result}`)
            
            // 储存result
            this.$store.commit('setResult', result)

            // 识别成功，保存用户的数据到数据库，并且获取分享id
            // this.success(response.data.result)
            axios.post(this.$store.state.hostname + '/scanuser/create', {
              // 微信id
              wxId: this.$store.state.wxUser.openid,
              // 头像
              avatar: this.$store.state.wxUser.headimgurl,
              // 微信id
              nickname: this.$store.state.wxUser.nickname,
              // 上传图片的地址
              imageUrl: '上传图片的七牛地址，目前应该不需要',
              // 识别的结果，哪几个政府工作报告
              result: result
            })
              .then((response) => {
                // console.log(response)

                if (response.data.code === 0 && response.data.shareId) {
                  // 设置分享数据，以及分享链接
                  
                  // 储存shareId
                  this.$store.commit('setShareId', response.data.shareId)
                  
                  // 把shareId储存到链接里
                  // history.replaceState(history.state, '', location.pathname + '?shareId=' + response.data.shareId + '#/upload')
                  // let url = window.location.href
                  // window.location.href = url

                  this.scanSuccess()
                }else{
                  this.scanFail({
                    code: 2,
                    message: '没有检测到任何物体，请重试'
                  })
                }
              })
              .catch((e) => {
                console.log('保存数据失败')
                this.scanFail({
                  code: 3,
                  message: '网络错误，请重试'
                })
              })
          } else {
            // 识别失败了，出现识别失败的动画，没有识别到任何物体吧
            this.scanFail({
              code: 2,
              message: '没有检测到任何物体，请重试'
            })
          }
        })
        .catch(error => {
          console.log(error)

          // 识别失败
          this.scanFail({
            code: 1,
            message: '网络请求失败，请检查网络环境后重试'
          })
        })
        .finally(() => {
          // 请求过百度的接口后，就不需要图片的base64了，清空，为再次返回提交页做准备
          this.$store.commit('clearBase64')
        })
    },
    
    // 识别成功
    scanSuccess (result) {
      // 跳转到结果页
      const player = document.getElementById('mp3-making')
      const nowTime = new Date().getTime()
      if (nowTime - this.startTime >= 2000) {
        // 识别时间花了超过2s，直接跳转
        
        player.pause()
        this.$router.replace('result')
      } else {
        // 识别时间没超过2s，要等到识别开始的2s后，再跳转
        setTimeout(() => {
          
          player.pause()
          this.$router.replace('result')
        }, this.startTime + 2000 - nowTime)
      }
    },

    // 识别失败，code 1 网络请求失败，code 2，没有识别到有效结果
    scanFail (error) {
      // 出现失败的提示，里面有返回重试的按钮
      this.showScanFail = true
      this.showScanning = false
    },

    retry () {
      this.showScanFail = false

      // 如果重新扫一扫的话，要清空input的值，不然重复上传一张图片会没有反应
      const obj = document.getElementById('uploader')
      obj.value = null

      const player = document.getElementById('mp3-text')
      player.play()
    }
  }
}
</script>

<style scoped>
  /* 上传图片页的样式 */
  .upload{
    position: relative;
  }
  .bg{
    background-size: 100% auto;
    background-image: url(../assets/p2/bg.jpg);
    background-repeat: no-repeat;
    background-position: 50% 0;
  }

  /* 标题 */
  .content{
    position: absolute;
    top: 1.125rem;
    left: 0;
    z-index: 2;
    width: 100%;
    height: 33rem;
    background-size: 100% auto;
    background-image: url(../assets/p2/content.png);
    background-repeat: no-repeat;
    background-position: 50% 0;
  }

  /* 标题整个区域 */
  .title-box{
    position: absolute;
    top: 2.1rem;
    left: 3.03rem;
    z-index: 9;
    width: 14.4rem;
    text-align: left;
  }

  .title-wrap{
    position: absolute;
    top: 0;
    left: 0;
    z-index: 8;
    width: 100%;
  }

  .title-box-shadow{
    position: absolute;
    top: 1px;
    left: 0;
    z-index: 7;
    width: 100%;
  }

  /* 标题的文字样式 */
  .title{
    margin: 0;
    line-height: 1.4rem;
    font-family: 'title_l';
    font-size: 1rem;
    color: #dceefe;
  }
  .title-box-shadow .title{
    color: #1b7a77;
    text-shadow: 0px 1px #ae65f5;
  }

  .title-2{
    margin-top: 1.46rem;
  }

  /* 标题里穿插的特殊文字样式 */
  .title-sp{
    font-size: 1.5rem;
    color: #f3ac3c;
    text-shadow: initial;
  }
  .title-box-shadow .title-sp{
    opacity: 0;
  }

  /* 标题下方的提示文字 */
  .tip{
    margin: 0;
    line-height: 16px;
    /* margin-top: 1rem; */
    font-size: 10px;
    color: #b8bfdd;
  }
  .title-box-shadow .tip{
    opacity: 0;
  }
  .tip-1{
    margin-top: .8rem;
  }

  /* 上传控件，隐藏不显示 */
  .uploader-box{
    position: absolute;
    top: 0;
    left: 0;
    width: 1px;
    height: 1px;
    overflow: hidden;
  }

  /* 上传状态时，禁止再次点击扫一扫，一个阻挡事件的层 */
  .uploading{
    position: absolute;
    top: 0;
    left: 0;
    z-index: 9;
    width: 100%;
    height: 100%;
  }
  
  /* 按钮的区域 */
  .btn-box{
    position: absolute;
    top: 24.94rem;
    left: 7.25rem;
    z-index: 5;
    width: 5.25rem;
    height: 4.34rem;
    font-size: 0;
  }
  .btn-box img{
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    vertical-align: top;
    visibility: hidden;
  }
  .btn-box .btn-show{
    visibility: visible;
  }

  /* 上传图片的按钮 */
  .uploader-agent{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 6;
  }

  /* 识别页的弹窗 */
  .alert-box{
    position: absolute;
    top: 0;
    left: 0;
    z-index: 20;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.9);
  }

  /* 识别中的页面 */
  .scanning{
    display: flex;
    display: -webkit-flex;
    justify-content: center;

    position: absolute;
    top: 0;
    left: 0;
    z-index: 20;
    width: 100%;
    height: 100%;
  }

  /* 识别中动画 */
  .scanning-content{
    position: absolute;
    top: 9.375rem;

    width: 148px;
    height: 175px;
  }

  .animate{
    position: relative;
    /* height: 10rem;
    overflow: hidden; */
  }

  .computer{
    width: 148px;
    height: 134px;
  }

  .wave-box{
    position: absolute;
    top: 8px;
    left: 6px;
    width: 128px;
    overflow: hidden;
    vertical-align: top;
    font-size: 0;
  }

  .wave{
    width: 557px;
  }

  .scanning-title{
    margin-top: 30px;
    font-size: 13px;
    color: #a7b0e5
  }

  /* 动画部分 */
  .anim-wave {
    width: 557px;
    -webkit-animation: wave 2s infinite linear;
    animation: wave 2s infinite linear;
  }
  @-webkit-keyframes wave {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translate3d(-217.5px, 4px, 0px);
    }
  }
  @keyframes wave {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translate3d(-217.5px, 4px, 0px);
    }
  }

  /* 文字淡入 */
  .fade1{
    -webkit-animation: fade 1s ease both;
    animation: fade 1s ease both;
  }
  .fade2{
    -webkit-animation: fade 1s 1s ease both;
    animation: fade 1s 1s ease both;
  }
  .fade3{
    -webkit-animation: fade 1s 2s ease both;
    animation: fade 1s 2s ease both;
  }
  .fade4{
    -webkit-animation: fade 1s 3s ease both;
    animation: fade 1s 3s ease both;
  }
  .fade5{
    -webkit-animation: fade 1s 4s ease both;
    animation: fade 1s 4s ease both;
  }
  .fade6{
    -webkit-animation: fade 1s 5s ease both;
    animation: fade 1s 5s ease both;
  }
  @-webkit-keyframes fade {
    0% {opacity: 0;}
    100% {opacity: 1;}
  }
  @keyframes fade {
    0% {opacity: 0;}
    100% {opacity: 1;}
  }

  /* 识别失败了 */
  .scanfail{
    display: flex;
    display: -webkit-flex;
    justify-content: center;

    position: absolute;
    top: 0;
    left: 0;
    z-index: 20;

    width: 100%;
    height: 100%;
  }

  .scanfail-content{
    position: absolute;
    top: 2.54rem;

    width: 9.6rem;
  }

  .computer2{
    position: absolute;
    top: 6.94rem;

    width: 9.6rem;
    text-align: center;
  }
  .computer2 img{
    width: 9.6rem;
  }

  .retry-btn{
    position: absolute;
    top: 17.9rem;

    width: 100%;
    text-align: center;
  }
  .retry-btn img{
    width: 5.94rem;
  }
</style>
